// extracted by mini-css-extract-plugin
module.exports = {"image":"GvyoP","legend":"_22Hi6","title":"_10wDi","subtitle":"_3MStH","cta":"_2mO4O","ctaArrow":"_2Zpex"};